import { imageTypes, imageUrlTypeMappings } from "../../constants/images";
/**
 * This function return the image url based on the container width.
 *
 * @param param - An object includes image.
 * @param param.src - The image src.
 * @param param.type - The image type.
 * @param param.containerWidth - The image container width.
 * @param param.useDevPrefixedUrl - The image use Dev prefixed url.
 * @throws Will throw an error if the imageUrlTypeMappings is null.
 * @returns - Return the image url.
 */
const getImageUrlBasedOnContainerWidth = ({ src, type = imageTypes.DEFAULT_IMAGE, containerWidth, useDevPrefixedUrl, }) => {
    if (type === imageTypes.NO_TRANSFORM_IMAGE)
        return src;
    if (!imageUrlTypeMappings[type]) {
        const imageTypeString = Object.values(imageTypes).join(', ');
        throw new Error(`image type '${type}' not supported, available types: ${imageTypeString}`);
    }
    const [sizes, wrapImageUrl] = imageUrlTypeMappings[type];
    const closestImageWidth = (Array.isArray(sizes) && sizes.find((size) => containerWidth <= Number(size))) ||
        sizes[sizes.length - 1];
    if (!Array.isArray(wrapImageUrl)) {
        return wrapImageUrl(src, closestImageWidth, useDevPrefixedUrl);
    }
    return '';
};
export default getImageUrlBasedOnContainerWidth;
//# sourceMappingURL=getImageUrlBasedOnContainerWidth.js.map